import {Component, Input} from "@angular/core";
import {Nav} from "../../models/nav/nav";
import {Store} from "../../services/store.service";

@Component({
  selector: "work-form-container",
  templateUrl: "./work-form-container.component.html",
  providers: [Nav],
})
export class WorkFormContainerComponent {
  @Input() public paddingLeft: boolean = false;
  @Input() public forceBigView: boolean;

  constructor(public store: Store) {
  }
}
